import React, {useEffect, useState} from "react"
import StepNavigation from "../../components/StepNavigation";
import {appPages} from "../../App";
import ProductRulesApi from "../../api/ProductRulesApi";
import RuleGroup from "../../store/entities/rules/RuleGroup";
import {RulesGroupComponent} from "../../components/rule/RulesGroupComponent";
import ContentLoader from "react-content-loader";
import {noticeController} from "../../utils/NoticeController"
import {useHistory} from "react-router"

export const GeneralOfferPage = () => {
    const [groups, setGroups] = useState<RuleGroup[] | null>(null);
    const history = useHistory();

    useEffect(() => {
        ProductRulesApi.getGeneralOutput().then(
                (result) => {
                    const groupsOfRules = result.data.data
                    const ruleGroups: RuleGroup[] = []
                    for (const groupOfRules of groupsOfRules) {
                        ruleGroups.push(new RuleGroup(groupOfRules))
                    }
                    setGroups(ruleGroups)
                }
            )
    }, [])

    const saveGroups = (groups:RuleGroup[]|null) => {
        const data = []
        if(groups) {
            for (const group of groups) {
                for (const rule of group.rules) {
                    if(rule.child_rules.length > 0) {
                        if(rule.type === 'ozonOutputNameTemplate') {

                            data.push({
                                'input_type': rule.input.rule ? rule.input.rule.input_type : 'delete',
                                'input_name': rule.input.rule ? rule.input.rule.input_name : 'delete',
                                'input_unit': rule.input.input_unit_option?.value,
                                'output_type': rule.type,
                                'ozon_attribute_id': rule.ozon_attribute_id,
                                'ozon_category_id': rule.category_id
                            })

                        }
                        for (const child of rule.child_rules) {

                            data.push({
                                'input_type': child.input.rule ? child.input.rule.input_type : 'delete',
                                'input_name': child.input.rule ? child.input.rule.input_name : 'delete',
                                'input_unit': child.input.input_unit_option?.value,
                                'output_type': child.type,
                                'ozon_attribute_id': child.ozon_attribute_id,
                                'ozon_category_id': child.category_id
                            })

                        }
                    } else {

                        data.push({
                            'input_type': rule.input.rule ? rule.input.rule.input_type : 'delete',
                            'input_name': rule.input.rule ? rule.input.rule.input_name : 'delete',
                            'input_unit': rule.input.input_unit_option?.value,
                            'output_type': rule.type,
                            'ozon_attribute_id': rule.ozon_attribute_id,
                            'ozon_category_id': rule.category_id
                        })

                    }
                }
            }
        }
        return ProductRulesApi.saveAll(data).then(result=> {
            noticeController.success = ["Сохранено"]
            setTimeout(()=>noticeController.clearSuccess(), 1000)
            const groupsOfRules = result.data.data
            const ruleGroups: RuleGroup[] = []
            if(groupsOfRules) {
                for (const groupOfRules of groupsOfRules) {
                    ruleGroups.push(new RuleGroup(groupOfRules))
                }
                setGroups(ruleGroups)
            }

        })
    }


    return <div>
        <h1>3. Настройка общих характеристик</h1>
        <button className={'button green ozon_save'} onClick={()=>saveGroups(groups)}>Сохранить</button>
        {groups ?
            groups.map((el, index) => <RulesGroupComponent key={index} group={el} />) :
        <RulesGroupsContentLoader/>}
        <StepNavigation back={appPages.categoriesComparison} next={undefined} save_next={()=>saveGroups(groups).then(()=>history.push(appPages.offerAttributes))}/>
    </div>
}

export const RulesGroupsContentLoader = () => (
    <ContentLoader
        speed={2}
        width={800}
        height={610}
        viewBox="0 0 800 610"
        backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb"
    >
        <rect x="0" y="60" rx="10" ry="10" width="350" height="40" />
        <rect x="390" y="60" rx="10" ry="10" width="350" height="40" />

        <rect x="0" y="110" rx="10" ry="10" width="350" height="40" />
        <rect x="390" y="110" rx="10" ry="10" width="350" height="40" />

        <rect x="0" y="160" rx="10" ry="10" width="350" height="40" />
        <rect x="390" y="160" rx="10" ry="10" width="350" height="40" />

        <rect x="0" y="210" rx="10" ry="10" width="350" height="40" />
        <rect x="390" y="210" rx="10" ry="10" width="350" height="40" />

        <rect x="0" y="260" rx="10" ry="10" width="350" height="40" />
        <rect x="390" y="260" rx="10" ry="10" width="350" height="40" />

        <rect x="0" y="310" rx="10" ry="10" width="350" height="40" />
        <rect x="390" y="310" rx="10" ry="10" width="350" height="40" />

        <rect x="0" y="360" rx="10" ry="10" width="350" height="40" />
        <rect x="390" y="360" rx="10" ry="10" width="350" height="40" />

        <rect x="0" y="410" rx="10" ry="10" width="350" height="40" />
        <rect x="390" y="410" rx="10" ry="10" width="350" height="40" />

        <rect x="0" y="460" rx="10" ry="10" width="350" height="40" />
        <rect x="390" y="460" rx="10" ry="10" width="350" height="40" />

        <rect x="0" y="510" rx="10" ry="10" width="350" height="40" />
        <rect x="390" y="510" rx="10" ry="10" width="350" height="40" />

        <rect x="0" y="560" rx="10" ry="10" width="350" height="40" />
        <rect x="390" y="560" rx="10" ry="10" width="350" height="40" />

        <rect x="0" y="610" rx="10" ry="10" width="350" height="40" />
        <rect x="390" y="610" rx="10" ry="10" width="350" height="40" />

        <rect x="0" y="660" rx="10" ry="10" width="350" height="40" />
        <rect x="390" y="660" rx="10" ry="10" width="350" height="40" />
    </ContentLoader>
)